import { env } from "@/lib/env";

/**
 * Implicit-consent footer (PDR 011 D8 launch variant, #4224).
 *
 * The launch T&C consent mechanism: a static, informational footer on the
 * initial (pre-identity) login page stating that use of the site constitutes
 * acceptance of the Terms & Conditions and Privacy Policy. It does NOT gate the
 * login buttons, render a checkbox, or write any acceptance record — while the
 * `TC_VERSIONED_CONSENT` flag is OFF this is the ONLY consent surface; when that
 * flag is later flipped ON, consent is captured explicitly by the versioned flow
 * ({@link VersionedTermsGate}, #4204) and this footer is no longer the mechanism.
 *
 * The legal-document URLs are centralized in `lib/env` (config/env-driven, never
 * hardcoded — repo standard).
 */
export function ImplicitConsentFooter() {
  return (
    <p className="mt-4 text-center text-[11px] leading-snug text-gray-400">
      Use of this site constitutes acceptance of Xavior&apos;s{" "}
      <a
        href={env.termsUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="underline hover:text-gray-600"
      >
        Terms &amp; Conditions
      </a>{" "}
      and{" "}
      <a
        href={env.privacyUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="underline hover:text-gray-600"
      >
        Privacy Policy
      </a>
      .
    </p>
  );
}
